export function init() {
    const links = document.querySelectorAll('a[data-href]:not(.init)');
    
    links.forEach(link => {
        link.classList.add('init');
        link.addEventListener('click', (e) => {
            e.preventDefault();

            const href = atob(link.dataset.href);
            const domain = new URL(window.location).host;

            if (href.startsWith("/") || href.includes(domain)) {
                if (window.barba) {
                    window.barba.go(href);
                }
                else window.location.href = href;
            }

            else {
                if (link.target == "_blank") window.open(href);
                else window.location.href = href;
            }
        })
    })
}